import styled, { css } from "styled-components";
import { Row, Col } from "antd";
import ManageDatelineForm from "components/job/index/startJobStep/manageDateline/form";

const ManageTodoListNoTemplate = (props) => {
  // Component Props
  const { setDoneCreate } = props;
  return (
    <>
      <StyledChildRow gutter={4}>
        <Col span={24}>
          <StyledContainer>
            <ManageDatelineForm setDoneCreate={setDoneCreate} />
          </StyledContainer>
        </Col>
      </StyledChildRow>
    </>
  );
};

const StyledChildRow = styled(Row)`
  ${(props) =>
    props.$newJob &&
    css`
      padding: ${(props) => props.theme.spacing[4]};
    `};
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${(props) => props.theme.spacing[2]};
  max-height: 80vh;
  overflow-y: auto;
`;

export default ManageTodoListNoTemplate;
